<template>
<!-- Your content for selectStore page goes here -->
<!-- <van-popup v-model:show="self.isShow" position="right" :overlay="false" class="full-screen-popup">
            <div>
              内容
            </div>
        </van-popup> -->
<div v-if="self.isShow" class="full-screen-popup column">
    <!--搜索-->
    <div class="selectStoreTitle row flex-center">
        <div class="iconfont icon-arr backicon"  @click="backClick()"> </div>
        请选择门店
    </div>

    <div class="searchbar">
     <van-search placeholder="输入要搜索的门店" @input="editShopname" @clear="editShopname" v-model="searchContent" />
    </div>

    <div class="overflow-y flex-1  listScroll" id="patientList">
        <div class="shoplist">
            <!---->
            <div class="shopitem" :class="row.value==current?'active':''" v-for="(row, index) in list" :key="index" @click="clickStore(row)">
                {{ row.name }}
            </div>
        </div>
    </div>

    <!-- <div class="p-footbtn">
        <div class="flex-1">
            <div class="btn backBtn P-Cursor" @click="backClick()">
                返回
            </div>
        </div>
    </div> -->
</div>
</template>

<script>
import PinyinMatch from "pinyin-match";
import func from "@/util/func.js"

export default {
    name: 'selectStore',
    props: {
        self: {
            type: Object,
            required: false,
            default: () => ({
                isShow: false
            })
        },
        clinicList: {
            type: Object,
            required: false,
            default: () => ([])
        }
    },
    components: {},
    data() {
        return {
            // Your data properties for selectStore page go here
            searchContent: "",
            list: [],
            listBack: [],
            current: ''
        };
    },
    setup() {
        // Your setup logic for selectStore page goes here
    },
    computed() {
        //定义一个 list 是通过 listBack元素的name 用 PinyinMatch 库匹配来的一个数组
    },
    mounted() {

        this.format();
        // Your mounted logic for selectStore page goes here
    },
    methods: {
        format() {
            let that = this;
            this.current = that.self.current;
            this.listBack = func.copyArr(that.clinicList);
            this.list = func.copyArr(that.clinicList);
        },
        // Your methods for selectStore page go here
        backClick() {
            this.self.isShow = false;
        },
        removeRepet(list, key) {
            //根据数组的某个值去重
            let map = new Map();
            list.forEach((item) => {
                if (!map.has(item[key])) map.set(item[key], item);
            });
            return [...map.values()];
        },
        editShopname() {
            let val = this.searchContent;
            if (val) {
                let result = [];
                this.listBack.forEach((i) => {
                    let m = PinyinMatch.match(i.name, val);
                    if (!m) {} else {
                        result.push(i);
                    }
                });

                // 将过滤后的数组重新赋给下拉列表数据
                result = this.removeRepet(result, "name");
                this.list = func.copyArr(result);
            } else {
                // 如果输入框为空, 则将下拉列表数据还原
                this.list = this.listBack;
            }
        },
        clickStore(row) {
            let that = this;
            that.$emit("storeChange", {
                row: row
            })
        }
    },
};
</script>

<style lang="scss" scoped>
@keyframes rightin {
    from {
        transform: translateX(100%);
        /* 初始状态在屏幕右侧外 */
    }

    to {
        transform: translateX(0);
        /* 最终状态向左移动到屏幕内 */
    }
}

/* Your styles for selectStore page go here */
.full-screen-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 8;
    background-color: #f6f6f6;
    animation: rightin 0.3s forwards;
    -webkit-animation: rightin 0.3s forwards;
}

.van-search__action {
    padding: 0 .833rem
}

.shoplist {
    padding: 0 .292rem;
}

.shopitem {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    /* 控制显示的行数 */
    text-align: left;
    padding: .292rem .125rem;
    border-bottom: .021rem solid #ccc;
    color: #333;

    &.active {
        color: #28B8C3;
    }
}

.backBtn {
    border: 1px solid #28B8C3;
    color: #28B8C3;
}

.selectStoreTitle {
    padding: .217rem .208rem .217rem .208rem;

    font-size: .292rem;
    text-align: left;
    background-color: #fff;
    .backicon{
        font-size: .375rem;
        color: #28B8C3;
        padding: 0 .15rem;
    }
}
.searchbar{
    margin-top: .15rem;
}

.listScroll{
    background-color: #fff;
    margin-top: .15rem;
}
    
</style>
